export function getPARoute(orderKey, status) {
  if (status === "Denied") {
    return { name: "denial-follow-up-order", params: { id: orderKey } };
  }
  if (status === "Initiated") {
    return { name: "create-submission", params: { id: orderKey } };
  }
  return { name: "check-my-coverage", params: { id: orderKey } };
}
